import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles } from 'lucide-react';
const bonuses = [{
  n: 'BONO #1',
  icon: '🏆',
  title: 'El Arte y el Diseño en los Mundiales',
  desc: 'Unidad didáctica evergreen: historia del diseño gráfico, carteles, mascotas y murales de los mundiales de fútbol. Perfecto para conectar Arte con cultura popular y diseño.',
  value: '$4.990',
  level: 'Primaria'
}, {
  n: 'BONO #2',
  icon: '📅',
  title: 'Efemérides y Calendario Escolar de Arte',
  desc: '16 fechas clave del año escolar argentino con contexto, referencia artística y actividad resuelta. Nunca más te agarra desprevenida una fecha especial.',
  value: '$4.990',
  level: 'Primaria'
}, {
  n: 'BONO #3',
  icon: '♻️',
  title: 'Arte con Materiales Reciclados y Bajo Presupuesto',
  desc: 'Proyectos completos con materiales cotidianos y reutilizables. Con nota de seguridad, referencias de artistas y alternativas económicas.',
  value: '$4.990',
  level: 'Primaria'
}, {
  n: 'BONO #4',
  icon: '🗺️',
  title: 'Arte Argentino y Latinoamericano',
  desc: 'Panorama completo desde el arte precolombino hasta el muralismo y el arte urbano contemporáneo. Berni, Xul Solar, Minujín, Martín Ron. Ficha de análisis y proyecto integrador.',
  value: '$4.990',
  level: 'Secundaria'
}, {
  n: 'BONO #5',
  icon: '📆',
  title: 'Efemérides y Calendario Escolar de Arte (Secundaria)',
  desc: 'Las mismas 16 fechas clave, con actividades pensadas para el nivel secundario: análisis crítico, debate, argumentación. Sin improvisación en ninguna fecha del año.',
  value: '$4.990',
  level: 'Secundaria'
}, {
  n: 'BONO #6',
  icon: '📋',
  title: 'Banco de Rúbricas y Evaluaciones Rápidas',
  desc: 'Rúbricas listas para dibujo, pintura, collage, diseño, análisis de obra, portafolio y presentación oral. Autoevaluación, coevaluación y seguimiento individual.',
  value: '$4.990',
  level: 'Secundaria'
}];
export function BonusSection() {
  return <section className="py-24 lg:py-32 bg-paper-main" data-id="element-15">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-17">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-terra-50 text-terra-600 font-medium text-xs uppercase tracking-widest mb-6 border border-terra-100" data-id="element-18">
            <Gift className="w-4 h-4" data-id="element-19" /> 6 Regalos exclusivos
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-medium text-ink-800 mb-6 leading-tight tracking-tight" data-id="element-20">
            Además recibís{' '}
            <span className="text-brand-500" data-id="element-21">6 bonos GRATIS</span>
          </h2>
          <p className="text-lg text-ink-600 font-normal" data-id="element-22">
            Por comprar hoy, sumás recursos especializados sin pagar un peso
            más.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-16" data-id="element-23">
          {bonuses.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08,
          duration: 0.8,
          ease: 'easeOut'
        }} className="group relative bg-paper-card rounded-[20px] p-8 shadow-soft border border-paper-border transition-shadow hover:shadow-card flex flex-col" data-id="element-24">
              <div className="flex justify-between items-start mb-4" data-id="element-25">
                <div className="bg-terra-50 text-terra-600 text-[10px] font-medium px-3 py-1 rounded-full uppercase tracking-widest border border-terra-100" data-id="element-26">
                  {b.n}
                </div>
                <div className={`text-[10px] font-medium px-3 py-1 rounded-full uppercase tracking-widest ${b.level === 'Primaria' ? 'bg-terra-500 text-white' : 'bg-brand-500 text-white'}`} data-id="element-27">
                  {b.level}
                </div>
              </div>
              <div className="flex items-start gap-5 mt-2 flex-1" data-id="element-28">
                <div className="text-4xl bg-paper-alt w-16 h-16 rounded-full flex items-center justify-center shrink-0" data-id="element-29">
                  {b.icon}
                </div>
                <div className="flex-1 flex flex-col" data-id="element-30">
                  <h3 className="font-serif font-medium text-lg text-ink-800 mb-3 leading-tight" data-id="element-31">
                    {b.title}
                  </h3>
                  <p className="text-ink-600 text-sm font-normal leading-relaxed mb-4" data-id="element-32">
                    {b.desc}
                  </p>
                  <div className="flex items-center gap-3 flex-wrap mt-auto" data-id="element-33">
                    <span className="text-ink-400 line-through text-sm font-medium" data-id="element-34">
                      {b.value}
                    </span>
                    <span className="bg-accent-100 text-accent-700 font-medium text-[10px] px-3 py-1 rounded-full uppercase tracking-widest" data-id="element-35">
                      GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-2xl mx-auto bg-brand-800 rounded-[20px] p-10 lg:p-12 text-center shadow-card relative overflow-hidden" data-id="element-36">
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-700/30 rounded-full blur-[80px]" data-id="element-37"></div>
          <div className="relative z-10" data-id="element-38">
            <Sparkles className="w-6 h-6 text-accent-400 mx-auto mb-4" data-id="element-39" />
            <p className="text-brand-200 font-medium mb-4 text-xs uppercase tracking-widest" data-id="element-40">
              Valor total de los 6 bonos
            </p>
            <div className="flex items-center justify-center gap-6 text-4xl md:text-5xl font-serif font-medium" data-id="element-41">
              <span className="text-brand-400 line-through" data-id="element-42">$29.940</span>
              <span className="text-accent-400" data-id="element-43">GRATIS</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}